'use client';

import { createContext } from 'react';

// Holds the default (non entry-specific) Contentful promotion content that the
// root layout fetches on the server and passes down (CON-8210). When present,
// `useContentfulPromotionContent()` returns this synchronously instead of
// suspending on Apollo `useSuspenseQuery`, which keeps SSR and the first client
// render aligned on one deterministic value under the `'use cache'` root layout.
//
// The default value `undefined` means "no provider in the tree" — distinct from
// a provided value of `null`, which means "no active promotion".
const PromotionContentContext = createContext(undefined);

export default PromotionContentContext;
